const USERS_URL = '/users';

export function usersApi(userId?: string) {
  if (userId) {
    return `${USERS_URL}/${userId}`;
  }

  return USERS_URL;
}

export function userPasswordApi(userId: string) {
  return `${usersApi(userId)}/password`;
}

export function geoListByUserId(userId: string) {
  return `${usersApi(userId)}/offer-geo`;
}

export function usersStatistic() {
  return `${usersApi()}/statistic`;
}

export function usersExtendedStatistic() {
  return `${usersApi()}/extended-statistic`;
}

export function filterUsers() {
  return `${usersApi()}/filter`;
}

export function publishers() {
  return `${usersApi()}/publishers`;
}
